export enum Permissions {
    ROLE_PRESTATION = 'ROLE_PRESTATION',
    ROLE_DEMANDES = 'ROLE_DEMANDES',
    ROLE_DEMANDES_EXTRACT = 'ROLE_DEMANDES_EXTRACT',
    ROLE_HEBERGEMENT = 'ROLE_HEBERGEMENT',
    ROLE_LIVRAISON = 'ROLE_LIVRAISON',
    ROLE_FACTURATION = 'ROLE_FACTURATION',
    ROLE_STATISTIQUE = 'ROLE_STATISTIQUE',
    ROLE_LECTURECAB = 'ROLE_LECTURECAB',
    ROLE_LECTURECAB_IMPORT = 'ROLE_LECTURECAB_IMPORT',
    ROLE_ADMINISTRATION = 'ROLE_ADMINISTRATION',
    ROLE_ADMIN_GLOBAL = 'ROLE_ADMIN_GLOBAL',
    ROLE_ADMIN_SITE = 'ROLE_ADMIN_SITE',
    ROLE_CLIENT_EXT = 'ROLE_CLIENT_EXT',
    ROLE_CLINANETT = 'ROLE_CLINANETT',
    ROLE_ANETT = 'ROLE_ANETT',
    ROLE_DISTRIBUTION = 'ROLE_DISTRIBUTION',
    ROLE_ADMIN_DISTRI = 'ROLE_ADMIN_DISTRI',
    ROLE_DAV = 'ROLE_DAV',
    ROLE_HEBERGEMENT_LINGERE = 'ROLE_HEBERGEMENT_LINGERE',
    ROLE_BORDEREAU = 'ROLE_BORDEREAU'
}
